export default {
  element_selector: ".lazy",
  class_loading: "lazy--loading",
  class_loaded: "lazy--loaded",
  class_error: "lazy--error",

  callback_reveal: (el) => {
    if ( el.complete && el.naturalWidth !== 0 ) {
      el.classList.remove('lazy--loading');
      el.classList.add('lazy--loaded');
    }
  }
};



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/configureLazyLoad.js